export default {
  SIGNATURES: {
    PENDING: 'PENDING',
    SIGNED: 'SIGNED',
  },
};
